import React from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";
import Autocomplete from '@mui/material/Autocomplete';

import { ConfirmCancelDialog } from "./ConfirmCancelDialog";
import { LanguageContext } from './LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};

var iniRooli;
var iniToiminto;

class AdminRooliOikeudetEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        var data = props.Daatta.filter(function (d) {
            return d.rooliOikeudetId === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            RooliOikeudetId: data[0].rooliOikeudetId,
            Rooli_Id: data[0].rooli_Id,
            Toiminto_Id: data[0].toiminto_Id,
            Created: data[0].created,
            Updated: data[0].updated,
            Username: data[0].username,
            Active: data[0].active,
            roolit: (Object.keys(props.lookupLists.roolit).map(function (d) { return { value: d, label: props.lookupLists.roolit[d] }; }) || []),
            toiminnot: (Object.keys(props.lookupLists.toiminnot).map(function (d) { return { value: d, label: props.lookupLists.toiminnot[d] }; }) || []),
        };

    }

    UNSAFE_componentWillMount() {
        var r = this.state.Rooli_Id || '';
        var k = this.state.Toiminto_Id || '';
        iniRooli = this.state.roolit.find(({ value }) => value === r.toString());
        iniToiminto = this.state.toiminnot.find(({ value }) => value === k.toString());
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RooliOikeudetId: this.state.data[0].rooliOikeudetId,
            Rooli_Id: this.state.data[0].rooli_Id,
            Toiminto_Id: this.state.data[0].toiminto_Id,
            Created: this.state.data[0].created,
            Updated: this.state.data[0].updated,
            Username: this.state.data[0].username,
            Active: this.state.data[0].active
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            RooliOikeudetId: this.state.RooliOikeudetId,
            Rooli_Id: this.state.Rooli_Id,
            Toiminto_Id: this.state.Toiminto_Id,
            Created: this.state.Created,
            Updated: this.state.Updated,
            Username: this.state.Username,
            Active: this.state.Active
        });

        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({
            jotainMuuttui: true
        });
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { roolit, toiminnot } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={this.state.open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.AdminRooliOikeudet.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <Autocomplete
                            options={roolit}
                            defaultValue={iniRooli}
                            getOptionLabel={(option) => option.label}
                            style={{ width: 400 }}
                            onChange={(event, newValue) => this.handleListChange(event, newValue, 'Rooli_Id')}
                            renderInput={(params) => (
                                <TextField {...params} required={true} variant="standard" label={dictionary.AdminRooliOikeudet.Columns[1]} placeholder={dictionary.TextBoxLabel} />
                            )}
                        />
                        <Autocomplete
                            options={toiminnot}
                            defaultValue={iniToiminto}
                            getOptionLabel={(option) => option.label}
                            style={{ width: 400 }}
                            onChange={(event, newValue) => this.handleListChange(event, newValue, 'Toiminto_Id')}
                            renderInput={(params) => (
                                <TextField {...params} required={true} variant="standard" label={dictionary.AdminRooliOikeudet.Columns[2]} placeholder={dictionary.TextBoxLabel} />
                            )}
                        />
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "AdminRooliOikeudetEdit" })(AdminRooliOikeudetEdit);
